export default __webpack_public_path__ + "static/media/mystery-pack.cfe437bc.png";